import React, { useMemo } from "react";
import { Form, Formik, getIn } from "formik";
import KC_Input from "../../../../designsystem/KC_FormInput/KC_Input";
import KC_PhoneInput from "../../../../designsystem/KC_PhoneInput/KC_PhoneInput";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../designsystem/ds_commons";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import ShippingAddressForm from "../../../../components/ShippingAddressForm/ShippingAddressForm";
import { tt } from "../../../../utils/i18n/i18n";
import BusinessUser from "@tootsweet/model/entities/BusinessUser";
import Address from "@tootsweet/model/entities/Address";
import { pay_bill_validation_schema } from "../pay_bill_validation_schema";

interface Props {
  businessUser: BusinessUser;
  shippingAddress?: Address;
  onSubmit: (values: BusinessUser) => Promise<void>;
}

export default function ShippingAddressStep(props: Props) {
  return (
    <Formik<BusinessUser>
      initialValues={{
        ...props.businessUser,
        shippingAddress: props.shippingAddress || {
          countryCode: "",
          country: "",
          line1: "",
          postalCode: "",
          city: "",
          name: "",
          phoneNumber: ""
        }
      }}
      onSubmit={props.onSubmit}
      enableReinitialize={true}
      validationSchema={pay_bill_validation_schema}
    >
      {({ setFieldValue, values, errors, touched }) => {
        const isCountryNotFrance = useMemo(
          () =>
            !!values.shippingAddress?.countryCode &&
            values.shippingAddress.countryCode.toLowerCase() !== "fr",
          [values.shippingAddress?.countryCode]
        );

        return (
          <Form>
            <div className="d-flex flex-column flex-md-row st-gap mb-3">
              <div className="w-100 flex-grow-1">
                <label>
                  <KC_UIText
                    weight={KC_Weights.bold}
                    text={tt("info_delivering_delivery_contact")}
                  />
                </label>
                <KC_Input
                  id="shippingAddress_name"
                  placeholder={tt("info_delivering_shipping_name_placeholder")}
                  htmlFor={"shippingAddress.name"}
                  setFieldValue={setFieldValue}
                  required={true}
                  value={values.shippingAddress?.name || ""}
                />
                {getIn(touched, "shippingAddress.name") &&
                  getIn(errors, "shippingAddress.name") && (
                    <div className="text-danger mt-1">
                      {getIn(errors, "shippingAddress.name")}
                    </div>
                  )}
              </div>
              <div className="w-100 flex-grow-1">
                <label>
                  <KC_UIText
                    weight={KC_Weights.bold}
                    text={tt("info_delivering_phone_number")}
                  />
                </label>
                <KC_PhoneInput
                  id={"shippingAddress_pn"}
                  placeholder={tt(
                    "info_delivering_shipping_phone_placeholder"
                  )}
                  htmlFor={"shippingAddress.phoneNumber"}
                  setFieldValue={setFieldValue}
                  required={true}
                  errors={errors}
                  value={values?.shippingAddress?.phoneNumber || ""}
                  defaultCountry={
                    (values?.shippingAddress?.countryCode?.toLowerCase() as any) ||
                    "fr"
                  }
                />
                {getIn(touched, "shippingAddress.phoneNumber") &&
                  getIn(errors, "shippingAddress.phoneNumber") && (
                    <div className="text-danger mt-1">
                      {getIn(errors, "shippingAddress.phoneNumber")}
                    </div>
                  )}
              </div>
            </div>
            <ShippingAddressForm
              address={values.shippingAddress}
              setFieldValue={setFieldValue}
              disabled={false}
            />
            <div className="mt-4 d-flex justify-content-end">
              <KC_Button
                text={tt("continue")}
                size={KC_ButtonSize.Large}
                type="submit"
                isPrimary={true}
                disabled={isCountryNotFrance}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
